<script lang="ts">

    import {Utils} from "../util";
    import {ASSET_URL, WEBSITE_URL} from "../config";
    import type {Community, Property} from "../models/model";
    import Location from "./Location.svelte";
    import Answers from "./Answers.svelte";
    import Card from "./Card.svelte";
    import PactInfos from "./PactInfos.svelte";
    import {_} from '../services/i18n';
    import SearchFilter from "./SearchFilter.svelte";
    import Legend from "./Legend.svelte";

    export let selectedPropertyAnswers: { [id: number]: any } = {};
    export let showFilter = false


    export let communityData: Community | null;

    export let propertyList: Property[] = [];

    export let isPhoneSize = false;

    export let selectedSearchCommunity: string;

    function handleParentClick(event:any) {
        event.stopPropagation();
    }
</script>

<!-- toggle if you click anywhere in the whole component
<svelte:window on:click={() => expanded = false}/>
-->


<span on:click={handleParentClick}>
<div class="flex-row flex-wrap w-100 sidebar search-sidebar" style="">
    <SearchFilter bind:selectedSearchCommunity></SearchFilter>
</div>

    <!-- disabled for now:
    {#if mapType == 'full'}
    <div class="flex-row flex-wrap w-100 sidebar filter-sidebar" style="">

      <Accordion title="{$_('filter.title')}" bind:expanded={showFilter}>
          <div slot="content">
              only debugging:
              <br>answers:<br>
              {JSON.stringify(selectedPropertyAnswers)}

              <PropertyFilter bind:values={selectedPropertyAnswers}
                              options={propertyList}/>
          </div>
      </Accordion>

    </div>
    {/if}
     -->
<slot name="map"></slot>
<div class="flex-row flex-wrap w-100 sidebar result-sidebar {communityData ? '' : 'intro' }" style="">
    <Card title="{communityData?.name ? Utils.chooseTranslation(communityData?.name) : ''}">
        <div slot="content">
            {#if communityData != null}
                <div class="divider fullwidth"></div>
                {#if mapType == 'full'}
                    <Location communityData={communityData}></Location>
                    <Answers properties={propertyList} data={communityData?.public_answers}
                             hasPact={communityData?.dateOfSignaturePact}></Answers>
                {:else}
                    <PactInfos communityData={communityData}></PactInfos>
                {/if}
                {#if communityData.hasPact}
                    {#if mapType == 'full'}
                        <a class="mfi-btn"
                           href="{WEBSITE_URL}/{$_('single-page.slug')}/?short={communityData?.key}">{$_('morePactInfoBtn')}</a>
                    {:else}
                        <a class="mfi-btn"
                           href="{WEBSITE_URL}/{$_('single-page.slug')}/?short={communityData?.key}">{$_('moreInfoBtn')}</a>
                    {/if}
                {/if}
            {:else}
                <div class="intro-msg">
                    <span><img src="{ASSET_URL}/assets/img/icons/arrow_left.svg"></span>
                    <span>{$_('introText')}</span>
                </div>
            {/if}

        </div>
    </Card>
</div>

</span>
<div class="flex-row flex-wrap w-100 sidebar legend-sidebar" class:small-card={mapType != 'pact'}
     style="margin-top:15px;">
    <Card title="{$_('legend.title')}">
        <div slot="content">
            <Legend/>

        </div>
    </Card>
</div>

<style lang="scss">
  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .divider {

    &.fullwidth {
      position: absolute;
      left: 0;

    }

    margin-top: -10px;
    width: 100%;
    border: 2px solid #F8F7F7;
  }

  .sidebar {
    position: relative;
  }

  .filter-sidebar {
    z-index: 99;
    //background:lightcoral;
    margin-bottom: 80px;
  }

  .search-sidebar {
    z-index: 20;
    margin-bottom: 20px;
  }

  .result-sidebar {
    z-index: 10;
    //background:cadetblue;
    //margin-bottom:142px;
  }

  .intro-msg {

    display: flex;
    align-items: center;
    font-size: 20px;
    margin: 0;

    img {
      height: 70px;
      margin-bottom: 0;
    }

    span:first-child {
      display: flex;
      margin-right: 1rem;
    }

    span {
      align-self: center;
      margin: 0;
    }

    .filter-sidebar {
      z-index: 99;
      //background:lightcoral;
      margin-bottom: 80px;
    }

  }
</style>
